import isCreditCard from 'validator/es/lib/isCreditCard';
import isEmpty from 'validator/es/lib/isEmpty';
import isLength from 'validator/es/lib/isLength';
import isNumeric from 'validator/es/lib/isNumeric';
import matches from 'validator/es/lib/matches';
import { FormValidation } from './FormValidation';
export var CardBrand;
(function (CardBrand) {
    function detectCardBrand(cardno) {
        if (cardno.startsWith("4")) {
            return "VISA";
        }
        if (cardno.startsWith("35")) {
            return "JCB";
        }
        if (cardno.startsWith("5") || cardno.startsWith("2")) {
            return "MASTER";
        }
        if (cardno.startsWith("36") || cardno.startsWith("38") || cardno.startsWith("39") || cardno.startsWith("30")) {
            return "DINERS";
        }
        if (cardno.startsWith("34") || cardno.startsWith("37")) {
            return "AMEX";
        }
        return "UNIONPAY";
    }
    CardBrand.detectCardBrand = detectCardBrand;
    function validate(card) {
        const constraints = [
            // カード番号
            {
                field: "cardno",
                validate: [
                    [isEmpty, "入力必須の項目です", false, null],
                    [isCreditCard, "正しいカード番号を入力してください", true, null],
                ],
            },
            // 名義人
            {
                field: "holdername",
                validate: [
                    [isEmpty, "入力必須の項目です", false, null],
                    [matches, "半角英数字、および“ “ (スペース) ,(コンマ) .(ピリオド) -(ハイフン)/(スラッシュ)のみ入力可能です", true, /^[\w\,\.\-\/ ]+$/],
                    [isLength, "50文字以内で入力してください", true, { min: 1, max: 50 }]
                ]
            },
            // 有効期限(月)
            {
                field: "expiremonth",
                validate: [
                    [isEmpty, "有効期限(月)は入力必須の項目です", false, null],
                ]
            },
            // 有効期限(年)
            {
                field: "expireyear",
                validate: [
                    [isEmpty, "有効期限(年)は入力必須の項目です", false, null],
                ]
            },
            // セキュリティコード
            {
                field: "cvc",
                validate: [
                    [isEmpty, "入力必須の項目です", false, null],
                    [isNumeric, "数字のみで入力してください", true, null],
                    [isLength, "3~4文字以内で入力してください", true, { min: 3, max: 4 }],
                ]
            },
        ];
        const errors = FormValidation.validate(constraints, card);
        return errors;
    }
    CardBrand.validate = validate;
})(CardBrand || (CardBrand = {}));
